const tableGroupsConfig = [
  { id: 1, name: 'NUMBER', isSortable: false, info: '', field: 'number' },
  {
    id: 2,
    name: 'TITLE',
    isSortable: true,
    info: '',
    field: 'createdDate'
  },
  {
    id: 3,
    name: 'HEADING',
    isSortable: false,
    info: '',
    field: 'articleTitle'
  },
  {
    id: 4,
    name: 'QUANTITY',
    isSortable: true,
    info: '',
    field: 'articlesLen'
  },
  {
    id: 5,
    name: 'ATTENDANCE',
    isSortable: true,
    info: 'AUDIENCE',
    field: 'totalAttendance'
  },
  {
    id: 6,
    name: 'VIEWS_COUNT',
    isSortable: true,
    info: 'VIEWING',
    field: 'totalAverageAttendance'
  },
  { id: 7, name: 'NOTIF', isSortable: false, info: '', field: 'notif' },
  { id: 8, name: 'DELL', isSortable: false, info: '', field: 'dell' }
];

export default tableGroupsConfig;
